// // import React, { useState, useEffect, useRef } from "react";
// // import styled from "styled-components";
// // import { ref, set, push, onValue, remove, update } from "firebase/database";
// // import { FaEdit, FaTrash, FaShoppingCart, FaShareAlt } from "react-icons/fa";
// // import { FaUserTie, FaPhoneAlt, FaArrowRight } from "react-icons/fa";

// // import {
// //   ref as storageRef,
// //   getDownloadURL,
// //   uploadBytesResumable,
// // } from "firebase/storage";
// // import { db, storage } from "../firebaseConfig";
// // import { useNavigate } from "react-router-dom"; // top me import

// // /* ---------------- BUTTONS ---------------- */

// // // Common Gradient Button

// // const GradientButton = styled.button`
// //   padding: 12px 24px;
// //   font-size: 16px;
// //   font-weight: bold;
// //   border: none;
// //   border-radius: 50px;
// //   cursor: pointer;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   gap: 8px;

// //   background: linear-gradient(45deg, #6a11cb, #2575fc);
// //   color: white;
// //   transition: all 0.3s ease-in-out;
// //   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

// //   &:hover {
// //     transform: translateY(-3px) scale(1.05);
// //     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
// //     background: linear-gradient(45deg, #2575fc, #6a11cb);
// //   }

// //   svg {
// //     transition: transform 0.3s ease-in-out;
// //   }

// //   &:hover svg {
// //     transform: translateX(5px);
// //   }

// //   /* 🔹 Responsive */
// //   @media (max-width: 768px) {
// //     width: 100%;
// //     font-size: 15px;
// //     padding: 10px 18px;
// //   }

// //   @media (max-width: 480px) {
// //     font-size: 14px;
// //     padding: 8px 16px;
// //   }
// // `;
// // const GradientButton2 = styled.button`
// //   padding: 12px 24px;
// //   font-size: 16px;
// //   font-weight: bold;
// //   border: none;
// //   border-radius: 50px;
// //   cursor: pointer;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   gap: 8px;

// //   background: linear-gradient(45deg, #6a11cb, #2575fc);
// //   color: #ffffffff;
// //   transition: all 0.3s ease-in-out;
// //   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

// //   &:hover {
// //     transform: translateY(-3px) scale(1.05);
// //     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
// //     background: linear-gradient(45deg, #2575fc, #6a11cb);
// //   }

// //   svg {
// //     transition: transform 0.3s ease-in-out;
// //   }

// //   &:hover svg {
// //     transform: translateX(5px);
// //   }

// //   /* 🔹 Responsive */
// //   @media (max-width: 768px) {
// //     width: 90%;
// //     font-size: 15px;
// //     padding: 10px 18px;
// //   }

// //   @media (max-width: 480px) {
// //     font-size: 14px;
// //     padding: 8px 16px;
// //   }
// // `;
// // const ButtonContainer = styled.div`
// //   margin-top: 2rem;
// //   display: flex;
// //   gap: 1rem;
// //   justify-content: center;
// //   flex-wrap: wrap;
// // `;
// // const GradientButton1 = styled.button`
// //   padding: 12px 24px;
// //   font-size: 16px;
// //   font-weight: bold;
// //   border: none;
// //   border-radius: 50px;
// //   cursor: pointer;
// //   display: flex;
// //   align-items: center;
// //   margin-top: 13px;
// //   margin-bottom: 13px;
// //   justify-content: center;
// //   gap: 8px;

// //   background: linear-gradient(45deg, #6a11cb, #2575fc);
// //   color: white;
// //   transition: all 0.3s ease-in-out;
// //   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

// //   &:hover {
// //     transform: translateY(-3px) scale(1.05);
// //     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
// //     background: linear-gradient(45deg, #2575fc, #6a11cb);
// //   }

// //   svg {
// //     transition: transform 0.3s ease-in-out;
// //   }

// //   &:hover svg {
// //     transform: translateX(5px);
// //   }

// //   /* 🔹 Responsive */
// //   @media (max-width: 768px) {
// //     width: 90%;
// //     font-size: 15px;
// //     padding: 10px 18px;
// //   }

// //   @media (max-width: 480px) {
// //     font-size: 14px;
// //     padding: 8px 16px;
// //   }
// // `;
// // const ResponsiveParagraph = styled.p`
// //   max-width: 800px;
// //   margin: 20px auto;
// //   text-align: center;
// //   font-size: 18px;
// //   line-height: 1.6;
// //   color: #444;
// //   padding: 0 15px;

// //   @media (max-width: 768px) {
// //     font-size: 14px;
// //     line-height: 1.5;

// //     padding: 0 10px;
// //   }

// //   @media (max-width: 480px) {
// //     font-size: 13px;
// //     line-height: 1.4;
// //     padding: 0 10px;
// //   }
// // `;
// // // Edit Button
// // const EditButtonStyled = styled(GradientButton)`
// //   background: linear-gradient(45deg, #f7971e, #ffd200);

// //   &:hover {
// //     background: linear-gradient(45deg, #ffd200, #f7971e);
// //   }
// // `;

// // // Delete Button
// // const DangerButton = styled(GradientButton)`
// //   background: linear-gradient(45deg, #ff416c, #ff4b2b);

// //   &:hover {
// //     background: linear-gradient(45deg, #ff4b2b, #ff416c);
// //   }
// // `;

// // // Button Row Wrapper
// // const ButtonRow = styled.div`
// //   display: flex;
// //   justify-content: center;
// //   align-items: center;
// //   gap: 15px;
// //   margin-top: 15px;
// //   flex-wrap: wrap;

// //   @media (max-width: 480px) {
// //     flex-direction: column;
// //     width: 100%;
// //     gap: 12px;

// //     button {
// //       width: 100%;
// //       max-width: 320px;
// //     }
// //   }
// // `;

// // /* ---------------- LAYOUT + INPUTS ---------------- */

// // const MainContainer = styled.div`
// //   margin: 20;
// //   padding: 0;
// //   box-sizing: border-box;
// //   display: flex;
// //   flex-direction: column;
// //   align-items: center;
// //   margin-bottom: 20px;
// // `;

// // const InputRow = styled.div`
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   gap: 12px;
// //   margin: 20px auto;
// //   max-width: 500px;
// //   background: #f9f9f9;
// //   border: 1px solid #ddd;
// //   border-radius: 8px;
// //   padding: 10px 15px;
// //   box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

// //   @media (max-width: 768px) {
// //     flex-direction: column;
// //     width: 90%;
// //     gap: 8px;
// //     padding: 12px;
// //   }

// //   @media (max-width: 480px) {
// //     width: 100%;
// //     border-radius: 6px;
// //     padding: 10px;
// //   }
// // `;

// // const StyledInput = styled.input`
// //   flex: 1;
// //   padding: 12px 15px;
// //   border: none;
// //   outline: none;
// //   font-size: 16px;
// //   border-radius: 6px;
// //   background: white;
// //   box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);

// //   @media (max-width: 768px) {
// //     width: 100%;
// //     font-size: 15px;
// //     padding: 10px 12px;
// //   }

// //   @media (max-width: 480px) {
// //     font-size: 14px;
// //     padding: 8px 10px;
// //   }
// // `;

// // const StyledButton = styled(GradientButton)`
// //   border-radius: 8px;
// //   padding: 12px 24px;
// //   font-size: 1rem;
// //   cursor: pointer;
// //   color: #ffffffff;
// //   transition: all 0.3s ease;

// //   &:hover {
// //     transform: scale(1.05);
// //   }

// //   /* Tablet */
// //   @media (max-width: 768px) {
// //     padding: 10px 20px;
// //     font-size: 0.95rem;
// //   }

// //   /* Mobile */
// //   @media (max-width: 480px) {
// //     width: 100%; /* mobile pe full width button */
// //     padding: 12px;
// //     font-size: 0.9rem;
// //     border-radius: 6px;
// //   }
// // `;

// // /* ---------------- IMAGE UPLOAD + FORM ---------------- */

// // const ImagePicker = styled.div`
// //   margin: 20px;
// //   display: flex;
// //   flex-direction: column;
// //   align-items: center;
// // `;

// // const ImagePreviewContainer = styled.div`
// //   width: 100%;
// //   display: flex;
// //   flex-wrap: wrap;
// //   gap: 20px;
// //   justify-content: center;
// //   align-items: center;
// //   margin-top: 20px;
// // `;

// // const ImagePreviewImg = styled.img`
// //   width: 150px;
// //   border-radius: 10px;
// //   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
// //   margin-bottom: 10px;
// // `;

// // const TitleInput = styled.input`
// //   margin-top: 10px;
// //   padding: 10px;
// //   font-size: 18px;
// //   width: 100%;
// //   max-width: 400px;
// //   border-radius: 5px;
// //   border: 1px solid #ccc;
// // `;

// // const DescriptionInput = styled.textarea`
// //   margin-top: 10px;
// //   padding: 10px;
// //   font-size: 16px;
// //   width: 100%;
// //   max-width: 400px;
// //   height: 100px;
// //   border-radius: 5px;
// //   border: 1px solid #ccc;
// // `;

// // const UrlInput = styled.input`
// //   margin-top: 10px;
// //   padding: 10px;
// //   font-size: 16px;
// //   width: 100%;
// //   max-width: 400px;
// //   border-radius: 5px;
// //   border: 1px solid #ccc;
// // `;

// // const CountrySelect = styled.select`
// //   margin-top: 10px;
// //   padding: 10px;
// //   font-size: 16px;
// //   width: 100%;
// //   max-width: 400px;
// //   border-radius: 5px;
// //   border: 1px solid #ccc;
// // `;

// // const SubmitButton = styled(GradientButton)`
// //   margin-top: 20px;
// //   border-radius: 8px;
// // `;

// // const CancelButton = styled(DangerButton)`
// //   margin-top: 10px;
// //   border-radius: 8px;
// // `;

// // /* ---------------- PRODUCT CARD ---------------- */

// // const Card = styled.div`
// //   border-radius: 16px;
// //   width: 100%;
// //   max-width: 350px;
// //   padding: 15px;

// //   background: #fff;
// //   border: 1px solid rgba(0, 0, 0, 0.08); /* subtle border */
// //   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
// //   display: flex;
// //   flex-direction: column;
// //   align-items: center;
// //   padding-bottom: 15px;
// //   // padding: 15px;
// //   transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;

// //   &:hover {
// //     transform: translateY(-8px) scale(1.03);
// //     box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
// //     border: 1px solid rgba(0, 0, 0, 0.15);
// //   }

// //   /* Responsive design */
// //   @media (max-width: 1024px) {
// //     max-width: 300px;
// //     padding: 12px;
// //   }

// //   @media (max-width: 768px) {
// //     max-width: 100%;
// //     padding: 10px;
// //   }

// //   @media (max-width: 480px) {
// //     max-width: 100%;
// //     padding: 12px;
// //     border-radius: 12px;
// //   }
// // `;

// // const CardImage = styled.img`
// //   width: 100%;
// //   object-fit: cover;
// //   border-radius: 10px;
// // `;

// // const FlagImg = styled.img`
// //   width: 40px;
// //   margin-top: 10px;
// //   height: 25px;
// //   object-fit: cover;
// //   border-radius: 4px;
// //   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

// //   @media (max-width: 768px) {
// //     width: 35px;
// //     height: 22px;
// //   }
// // `;

// // const TitleText = styled.h3`
// //   font-size: 1.2rem;
// //   font-weight: 600;
// //   margin-top: 10px;
// //   color: #0a2df3ff;

// //   @media (max-width: 768px) {
// //     font-size: 1rem;
// //   }
// // `;

// // const CardDescription = styled.p`
// //   font-size: 16px;
// //   color: #7c7979ff;
// //   padding: 0 10px;
// //   line-height: 1.6;
// //   text-align: center;
// // `;

// // const ResponsiveTitle = styled.h1`
// //   font-size: 2.5rem;
// //   text-align: center;
// //   padding: 10px;
// //   margin: 20px 0;

// //   /* Default text (black) */
// //   background: black;
// //   -webkit-background-clip: text;
// //   -webkit-text-fill-color: transparent;

// //   @media (max-width: 768px) {
// //     font-size: 2rem;
// //   }

// //   @media (max-width: 480px) {
// //     font-size: 1.5rem;
// //   }

// //   /* Span with gradient text + light background */
// //   span {
// //     display: inline-block;
// //     padding: 5px 10px;
// //     border-radius: 6px;

// //     /* Background box */
// //     background-color: rgba(240, 240, 240, 0.3);

// //     /* Gradient text */
// //     background-image: linear-gradient(90deg, #ffa600ff);
// //     -webkit-background-clip: text;
// //     -webkit-text-fill-color: transparent;
// //   }
// // `;

// // const ReadMoreButton = styled.button`
// //   background: none;
// //   border: none;
// //   color: #2575fc;
// //   font-weight: 600;
// //   cursor: pointer;
// //   margin-top: 6px;
// //   font-size: 14px;

// //   &:hover {
// //     text-decoration: underline;
// //   }
// // `;
// // const GradientSection = styled.div`
// //   width: 100%;
// //   padding: 16rem 2rem; /* Desktop default */
// //   background: linear-gradient(to bottom, #040274ff, #000000ff);

// //   color: white;
// //   text-align: center;

// //   @media (max-width: 1200px) {
// //     padding: 12rem 2rem; /* Large laptops/tablets */
// //   }

// //   @media (max-width: 992px) {
// //     padding: 10rem 1.5rem; /* Medium tablets */
// //   }

// //   @media (max-width: 768px) {
// //     padding: 8rem 1rem; /* Small tablets / large phones */
// //   }

// //   @media (max-width: 480px) {
// //     padding: 6rem 1rem; /* Mobile phones */
// //   }
// // `;

// // const GradientTitle = styled.h1`
// //   font-size: 2.5rem;
// //   font-weight: bold;
// //   margin-bottom: 1.5rem;
// //   color: #ffa600ff;

// //   @media (max-width: 768px) {
// //     font-size: 2rem;
// //   }
// // `;

// // const GradientText = styled.p`
// //   font-size: 1.2rem;
// //   line-height: 1.8;
// //   max-width: 700px;
// //   margin: 0 auto;

// //   @media (max-width: 768px) {
// //     font-size: 1rem;
// //   }
// // `;
// // /* ---------------- FLAGS ---------------- */

// // const countryFlags = {
// //   USA: "https://flagcdn.com/us.svg",
// //   UK: "https://flagcdn.com/gb.svg",
// //   Canada: "https://flagcdn.com/ca.svg",
// //   Germany: "https://flagcdn.com/de.svg",
// //   France: "https://flagcdn.com/fr.svg",
// //   Italy: "https://flagcdn.com/it.svg",
// //   UAE: "https://flagcdn.com/ae.svg",
// //   Spain: "https://flagcdn.com/es.svg",
// //   Australia: "https://flagcdn.com/au.svg",
// //   Pakistan: "https://flagcdn.com/pk.svg",
// // };

// // /* ---------------- COMPONENT ---------------- */
// // const CardImageWrapper = styled.div`
// //   position: relative;
// //   width: 100%;
// // `;

// // const ShareIcon = styled.div`
// //   position: absolute;
// //   top: 12px;
// //   right: 12px;
// //   background: linear-gradient(135deg, #0d0d0eff 0%, #022533ff 100%);
// //   border-radius: 50%;
// //   padding: 10px;
// //   cursor: pointer;
// //   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
// //   transition: all 0.3s ease;

// //   display: flex;
// //   align-items: center;
// //   justify-content: center;

// //   &:hover {
// //     transform: scale(1.15) rotate(10deg);
// //     background: linear-gradient(135deg, #141616ff 0%, #4facfe 100%);
// //     box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
// //   }

// //   svg {
// //     color: white;
// //     font-size: 18px;
// //   }
// // `;

// // const CardTitle = styled.div`
// //   display: flex;
// //   flex-direction: column; /* 👈 vertical column layout */
// //   align-items: center; /* center horizontally */
// //   justify-content: center;
// //   text-align: center;
// //   gap: 8px; /* space between flag and title */
// //   margin-bottom: 10px;
// // `;
// // const Home = () => {
// //   // same logic as before (no change)
// //   // sirf UI styling update ki gayi hai
// //   // 👇👇👇
// //   const [email, setEmail] = useState("");
// //   const [isAdmin, setIsAdmin] = useState(false);
// //   const [image, setImage] = useState(null);
// //   const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
// //   const [title, setTitle] = useState("");
// //   const [description, setDescription] = useState("");
// //   const [url, setUrl] = useState("");
// //   const [country, setCountry] = useState("");
// //   const [cards, setCards] = useState([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [search, setSearch] = useState("All");
// //   const [isEditing, setIsEditing] = useState(false);
// //   const [editCardId, setEditCardId] = useState(null);
// //   const [expandedCards, setExpandedCards] = useState({});
// //   const navigate = useNavigate(); // for navigation
// //   const imagePickerRef = useRef(null);
// //   const handleEdit = (card) => {
// //     setIsEditing(true);
// //     setEditCardId(card.id);
// //     setTitle(card.title);
// //     setDescription(card.description);
// //     setUrl(card.buyUrl);
// //     setCountry(card.country || "");
// //     setImage(card.url);
// //     setImagePreviewUrl(card.url);

// //     // 🔹 Scroll ImagePicker pe
// //     if (imagePickerRef.current) {
// //       imagePickerRef.current.scrollIntoView({
// //         behavior: "smooth",
// //         block: "start",
// //       });
// //     }
// //   };
// //   const toggleReadMore = (id) => {
// //     setExpandedCards((prev) => ({
// //       ...prev,
// //       [id]: !prev[id],
// //     }));
// //   };
// //   useEffect(() => {
// //     const cardsRef = ref(db, "cards");
// //     onValue(cardsRef, (snapshot) => {
// //       const data = snapshot.val();
// //       if (data) {
// //         const loadedCards = Object.entries(data).map(([key, value]) => ({
// //           id: key,
// //           ...value,
// //         }));
// //         setCards(loadedCards.reverse());
// //       }
// //     });
// //   }, []);

// //   const filteredCards = cards.filter((card) => {
// //     if (search.toLowerCase() === "all") return true;
// //     return card.country?.toLowerCase().includes(search.toLowerCase());
// //   });

// //   const handleEnterClick = () => {
// //     if (email === "usmanibadmin@gmail.com") {
// //       setIsAdmin(true);
// //       alert("Welcome Admin!");
// //     } else {
// //       setIsAdmin(false);
// //       alert("You are viewing the Client Panel!");
// //     }
// //   };

// //   const handleImageChange = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       const storageReference = storageRef(storage, `images/${file.name}`);
// //       const uploadTask = uploadBytesResumable(storageReference, file);

// //       uploadTask.on(
// //         "state_changed",
// //         null,
// //         (error) => console.error("Upload failed: ", error),
// //         () => {
// //           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
// //             setImage(downloadURL);
// //             setImagePreviewUrl(URL.createObjectURL(file));
// //           });
// //         }
// //       );
// //     }
// //   };

// //   const handleSubmit = () => {
// //     if (image && title && description && url && country) {
// //       if (isEditing && editCardId) {
// //         const cardRef = ref(db, "cards/" + editCardId);
// //         update(cardRef, {
// //           url: image,
// //           title,
// //           description,
// //           buyUrl: url,
// //           country,
// //           updatedAt: new Date().toISOString(),
// //         }).then(() => {
// //           alert("Product updated successfully!");
// //           resetForm();
// //         });
// //       } else {
// //         const newCardRef = push(ref(db, "cards"));
// //         const cardData = {
// //           url: image,
// //           title,
// //           description,
// //           buyUrl: url,
// //           country,
// //           createdAt: new Date().toISOString(),
// //         };
// //         set(newCardRef, cardData);
// //         resetForm();
// //       }
// //     } else {
// //       alert("Please fill in all fields before submitting.");
// //     }
// //   };

// //   const handleDelete = (id) => {
// //     const cardRef = ref(db, "cards/" + id);
// //     remove(cardRef).then(() => alert("Product deleted!"));
// //   };
// //   const handleShare = (card) => {
// //     const productLink = `${window.location.origin}/product/${card.id}`;

// //     if (navigator.share) {
// //       navigator.share({
// //         title: card.title,
// //         text: card.description,
// //         url: productLink,
// //       });
// //     } else {
// //       navigator.clipboard.writeText(productLink);
// //       alert("Link copied: " + productLink);
// //     }
// //   };

// //   const resetForm = () => {
// //     setImage(null);
// //     setImagePreviewUrl(null);
// //     setTitle("");
// //     setDescription("");
// //     setUrl("");
// //     setCountry("");
// //     setIsEditing(false);
// //     setEditCardId(null);
// //   };

// //   return (
// //     <>
// //       {/* <ImageSlider /> */}
// //       <MainContainer>
// //         <GradientSection>
// //           <GradientTitle>Making the Most of Your Spending Power</GradientTitle>
// //           <GradientText>
// //             Find the greatest prices on your preferred item. <br />
// //             We appreciate you making our affiliate website your go-to online
// //             purchasing resource. <br />
// //             We sincerely hope you have fun exploring our website and discovering
// //             fantastic offers and goods that satisfy your tastes and
// //             requirements.
// //           </GradientText>

// //           {/* Buttons */}
// //           <ButtonContainer>
// //       <GradientButton2 onClick={() => navigate("/aboutus")}>
// //   <FaUserTie size={18} /> About Us
// // </GradientButton2>

// // <GradientButton2 onClick={() => navigate("/contactus")}>
// //   <FaPhoneAlt size={18} /> Contact Us
// // </GradientButton2>
// //     </ButtonContainer>
// //         </GradientSection>

// //         <ResponsiveTitle>
// //           Welcome to <span>ClicknfindStore</span>
// //         </ResponsiveTitle>

// //         {/* Admin Email Input */}
// //         <InputRow>
// //           <StyledInput
// //             type="email"
// //             placeholder="Enter your email"
// //             value={email}
// //             onChange={(e) => setEmail(e.target.value)}
// //           />
// //           <StyledButton onClick={handleEnterClick}><FaArrowRight size={18} />Enter</StyledButton>
// //           {isAdmin && (
// //             <DangerButton
// //               onClick={() => {
// //                 setIsAdmin(false);
// //                 setEmail("");
// //                 alert("You have been logged out!");
// //               }}
// //             >
// //               Logout
// //             </DangerButton>
// //           )}
// //         </InputRow>
// //         <ResponsiveParagraph>
// //           <b>ClicknfindStore</b> is a participant in the <b>Amazon Associates Program</b>, an
// //           affiliate advertising program designed to provide a means for websites
// //           to earn advertising fees by promoting and linking to Amazon.com and
// //           its regional stores. We carefully select trending products, provide
// //           honest recommendations, and ensure that our visitors get updated deals
// //           with full transparency.
// //         </ResponsiveParagraph>

// //         {/* Admin Email Input */}

// //         {/* Customer Search */}

// //         <InputRow>
// //           <StyledInput
// //             type="text"
// //             placeholder="Search by country (All, USA, UK, )..."
// //             value={searchQuery}
// //             onChange={(e) => setSearchQuery(e.target.value)}
// //           />
// //           <StyledButton onClick={() => setSearch(searchQuery || "All")}>
// //             Search
// //           </StyledButton>
// //         </InputRow>
// //         {/* Admin Panel */}
// //         {isAdmin && (
// //           <>
// //             <ImagePicker ref={imagePickerRef}>
// //               <h2>
// //                 {isEditing ? "Edit Product" : "Admin Panel: Add Products"}
// //               </h2>
// //               <input
// //                 type="file"
// //                 accept="image/*"
// //                 onChange={handleImageChange}
// //               />
// //               {imagePreviewUrl && (
// //                 <ImagePreviewImg src={imagePreviewUrl} alt="Preview" />
// //               )}
// //               <TitleInput
// //                 type="text"
// //                 placeholder="Enter Product Title"
// //                 value={title}
// //                 onChange={(e) => setTitle(e.target.value)}
// //               />
// //               <DescriptionInput
// //                 placeholder="Enter Product Description"
// //                 value={description}
// //                 onChange={(e) => setDescription(e.target.value)}
// //               />
// //               <UrlInput
// //                 type="text"
// //                 placeholder="Enter Product URL"
// //                 value={url}
// //                 onChange={(e) => setUrl(e.target.value)}
// //               />
// //               <CountrySelect
// //                 value={country}
// //                 onChange={(e) => setCountry(e.target.value)}
// //               >
// //                 <option value="">Select Country</option>
// //                 {Object.keys(countryFlags).map((c) => (
// //                   <option key={c} value={c}>
// //                     {c}
// //                   </option>
// //                 ))}
// //               </CountrySelect>

// //               <SubmitButton onClick={handleSubmit}>
// //                 {isEditing ? "Update Product" : "Submit"}
// //               </SubmitButton>
// //               {isEditing && (
// //                 <CancelButton onClick={resetForm}>Cancel</CancelButton>
// //               )}
// //             </ImagePicker>
// //             <h2>Admin Panel: All Products</h2>
// //           </>
// //         )}

// //         {/* Products */}
// //         <ImagePreviewContainer>
// //           {filteredCards.length > 0 ? (
// //             filteredCards.map((card) => {
// //               const words = card.description.split(" ");
// //               const isExpanded = expandedCards[card.id];
// //               const shortText = words.slice(0, 30).join(" ");
// //               const shouldTruncate = words.length > 30;

// //               return (

// //                 <Card key={card.id}>
// //                   <CardImageWrapper>
// //                     <CardImage src={card.url} alt={card.title} />
// //                     <ShareIcon>
// //                       <FaShareAlt />
// //                     </ShareIcon>
// //                   </CardImageWrapper>

// //                   <CardTitle>
// //                     <TitleText>{card.title}</TitleText>
// //                     {card.country && countryFlags[card.country] && (
// //                       <FlagImg
// //                         src={countryFlags[card.country]}
// //                         alt={card.country}
// //                       />
// //                     )}
// //                   </CardTitle>

// //                   <CardDescription>
// //                     {isExpanded ? card.description : shortText}
// //                     {shouldTruncate && (
// //                       <>
// //                         {!isExpanded && "..."}
// //                         <br />
// //                         <ReadMoreButton onClick={() => toggleReadMore(card.id)}>
// //                           {isExpanded ? "Read Less" : "Read More"}
// //                         </ReadMoreButton>
// //                       </>
// //                     )}
// //                   </CardDescription>

// //                   {isAdmin ? (
// //                     <ButtonRow>
// //                       <EditButtonStyled onClick={() => handleEdit(card)}>
// //                         <FaEdit /> Edit
// //                       </EditButtonStyled>
// //                       <DangerButton onClick={() => handleDelete(card.id)}>
// //                         <FaTrash /> Delete
// //                       </DangerButton>
// //                       <GradientButton
// //                         onClick={() => (window.location.href = card.buyUrl)}
// //                       >
// //                         <FaShoppingCart /> Buy Now
// //                       </GradientButton>
// //                     </ButtonRow>
// //                   ) : (
// //                     <GradientButton1
// //                       onClick={() => (window.location.href = card.buyUrl)}
// //                     >
// //                       <FaShoppingCart /> Buy Now
// //                     </GradientButton1>
// //                   )}
// //                 </Card>
// //               );
// //             })
// //           ) : (
// //             <p>No products found for "{search}"</p>
// //           )}
// //         </ImagePreviewContainer>
// //       </MainContainer>
// //     </>
// //   );
// // };

// // export default Home;

// import React, { useState, useEffect, useRef } from "react";
// import styled from "styled-components";
// import { ref, set, push, onValue, remove, update } from "firebase/database";
// import { FaEdit, FaTrash, FaShoppingCart, FaShareAlt } from "react-icons/fa";
// import { FaUserTie, FaPhoneAlt, FaArrowRight, FaSearch } from "react-icons/fa";

// import {
//   ref as storageRef,
//   getDownloadURL,
//   uploadBytesResumable,
// } from "firebase/storage";
// import { db, storage } from "../firebaseConfig";
// import { useNavigate } from "react-router-dom"; // top me import

// /* ---------------- BUTTONS ---------------- */

// // Common Gradient Button

// const GradientButton = styled.button`
//   padding: 12px 24px;
//   font-size: 16px;
//   font-weight: bold;
//   border: none;
//   border-radius: 50px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;

//   background: linear-gradient(45deg, #6a11cb, #2575fc);
//   color: white;
//   transition: all 0.3s ease-in-out;
//   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

//   &:hover {
//     transform: translateY(-3px) scale(1.05);
//     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
//     background: linear-gradient(45deg, #2575fc, #6a11cb);
//   }

//   svg {
//     transition: transform 0.3s ease-in-out;
//   }

//   &:hover svg {
//     transform: translateX(5px);
//   }

//   /* 🔹 Responsive */
//   @media (max-width: 768px) {
//     width: 100%;
//     font-size: 15px;
//     padding: 10px 18px;
//   }

//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px 16px;
//   }
// `;
// const GradientButton2 = styled.button`
//   padding: 12px 24px;
//   font-size: 16px;
//   font-weight: bold;
//   border: none;
//   border-radius: 50px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;

//   background: linear-gradient(45deg, #6a11cb, #2575fc);
//   color: #ffffffff;
//   transition: all 0.3s ease-in-out;
//   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

//   &:hover {
//     transform: translateY(-3px) scale(1.05);
//     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
//     background: linear-gradient(45deg, #2575fc, #6a11cb);
//   }

//   svg {
//     transition: transform 0.3s ease-in-out;
//   }

//   &:hover svg {
//     transform: translateX(5px);
//   }

//   /* 🔹 Responsive */
//   @media (max-width: 768px) {
//     width: 90%;
//     font-size: 15px;
//     padding: 10px 18px;
//   }

//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px 16px;
//   }
// `;
// const ButtonContainer = styled.div`
//   margin-top: 2rem;
//   display: flex;
//   gap: 1rem;
//   justify-content: center;
//   flex-wrap: wrap;
// `;
// const GradientButton1 = styled.button`
//   padding: 12px 24px;
//   font-size: 16px;
//   font-weight: bold;
//   border: none;
//   border-radius: 50px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   margin-top: 13px;
//   margin-bottom: 13px;
//   justify-content: center;
//   gap: 8px;

//   background: linear-gradient(45deg, #6a11cb, #2575fc);
//   color: white;
//   transition: all 0.3s ease-in-out;
//   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

//   &:hover {
//     transform: translateY(-3px) scale(1.05);
//     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
//     background: linear-gradient(45deg, #2575fc, #6a11cb);
//   }

//   svg {
//     transition: transform 0.3s ease-in-out;
//   }

//   &:hover svg {
//     transform: translateX(5px);
//   }

//   /* 🔹 Responsive */
//   @media (max-width: 768px) {
//     width: 90%;
//     font-size: 15px;
//     padding: 10px 18px;
//   }

//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px 16px;
//   }
// `;
// const ResponsiveParagraph = styled.p`
//   max-width: 800px;
//   margin: 20px auto;
//   text-align: center;
//   font-size: 18px;
//   line-height: 1.6;
//   color: #444;
//   padding: 0 15px;

//   @media (max-width: 768px) {
//     font-size: 14px;
//     line-height: 1.5;

//     padding: 0 10px;
//   }

//   @media (max-width: 480px) {
//     font-size: 13px;
//     line-height: 1.4;
//     padding: 0 10px;
//   }
// `;
// // Edit Button
// const EditButtonStyled = styled(GradientButton)`
//   background: linear-gradient(45deg, #f7971e, #ffd200);

//   &:hover {
//     background: linear-gradient(45deg, #ffd200, #f7971e);
//   }
// `;

// // Delete Button
// const DangerButton = styled(GradientButton)`
//   background: linear-gradient(45deg, #ff416c, #ff4b2b);

//   &:hover {
//     background: linear-gradient(45deg, #ff4b2b, #ff416c);
//   }
// `;

// // Button Row Wrapper
// const ButtonRow = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 15px;
//   margin-top: 15px;
//   flex-wrap: wrap;

//   @media (max-width: 480px) {
//     flex-direction: column;
//     width: 100%;
//     gap: 12px;

//     button {
//       width: 100%;
//       max-width: 320px;
//     }
//   }
// `;

// /* ---------------- LAYOUT + INPUTS ---------------- */

// const MainContainer = styled.div`
//   margin: 20;
//   padding: 0;
//   box-sizing: border-box;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin-bottom: 20px;
// `;

// const InputRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 12px;
//   margin: 20px auto;
//   max-width: 500px;
//   background: #f9f9f9;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   padding: 10px 15px;
//   box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

//   @media (max-width: 768px) {
//     flex-direction: column;
//     width: 90%;
//     gap: 8px;
//     padding: 12px;
//   }

//   @media (max-width: 480px) {
//     width: 100%;
//     border-radius: 6px;
//     padding: 10px;
//   }
// `;

// const StyledInput = styled.input`
//   flex: 1;
//   padding: 12px 15px;
//   border: none;
//   outline: none;
//   font-size: 16px;
//   border-radius: 6px;
//   background: white;
//   box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);

//   @media (max-width: 768px) {
//     width: 100%;
//     font-size: 15px;
//     padding: 10px 12px;
//   }

//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px 10px;
//   }
// `;

// const StyledButton = styled(GradientButton)`
//   border-radius: 8px;
//   padding: 12px 24px;
//   font-size: 1rem;
//   cursor: pointer;
//   color: #ffffffff;
//   transition: all 0.3s ease;

//   &:hover {
//     transform: scale(1.05);
//   }

//   /* Tablet */
//   @media (max-width: 768px) {
//     padding: 10px 20px;
//     font-size: 0.95rem;
//   }

//   /* Mobile */
//   @media (max-width: 480px) {
//     width: 100%; /* mobile pe full width button */
//     padding: 12px;
//     font-size: 0.9rem;
//     border-radius: 6px;
//   }
// `;

// /* ---------------- IMAGE UPLOAD + FORM ---------------- */

// const ImagePicker = styled.div`
//   margin: 20px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

// const ImagePreviewContainer = styled.div`
//   width: 100%;
//   display: flex;
//   flex-wrap: wrap;
//   gap: 20px;
//   justify-content: center;
//   align-items: center;
//   margin-top: 20px;
// `;

// const ImagePreviewImg = styled.img`
//   width: 150px;
//   border-radius: 10px;
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
//   margin-bottom: 10px;
// `;

// const TitleInput = styled.input`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 18px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const DescriptionInput = styled.textarea`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   height: 100px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const UrlInput = styled.input`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// // const CountrySelect = styled.select`
// //   margin-top: 10px;
// //   padding: 10px;
// //   font-size: 16px;
// //   width: 100%;
// //   max-width: 400px;
// //   border-radius: 5px;
// //   border: 1px solid #ccc;
// // `;
// const CountrySelect = styled.select`
  
//   padding: 10px 12px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 8px;
//   border: 1px solid #ccc;
//   outline: none;
//   background: #fff;
//   box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);
//   transition: all 0.3s ease;

//   &:focus {
//     border-color: #2575fc;
//     box-shadow: 0 0 6px rgba(37, 117, 252, 0.5);
//   }

//   /* Tablet */
//   @media (max-width: 768px) {
//     font-size: 15px;
//     padding: 10px;
//     max-width: 100%;
//   }

//   /* Mobile */
//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px;
//     width: 100%;
//     border-radius: 6px;
//   }
// `;

// const SubmitButton = styled(GradientButton)`
//   margin-top: 20px;
//   border-radius: 8px;
// `;

// const CancelButton = styled(DangerButton)`
//   margin-top: 10px;
//   border-radius: 8px;
// `;

// /* ---------------- PRODUCT CARD ---------------- */

// const Card = styled.div`
//   border-radius: 16px;
//   width: 100%;
//   max-width: 350px;
//   padding: 15px;

//   background: #fff;
//   border: 1px solid rgba(0, 0, 0, 0.08); /* subtle border */
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding-bottom: 15px;
//   // padding: 15px;
//   transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;

//   &:hover {
//     transform: translateY(-8px) scale(1.03);
//     box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
//     border: 1px solid rgba(0, 0, 0, 0.15);
//   }

//   /* Responsive design */
//   @media (max-width: 1024px) {
//     max-width: 300px;
//     padding: 12px;
//   }

//   @media (max-width: 768px) {
//     max-width: 100%;
//     padding: 10px;
//   }

//   @media (max-width: 480px) {
//     max-width: 100%;
//     padding: 12px;
//     border-radius: 12px;
//   }
// `;

// const CardImage = styled.img`
//   width: 100%;
//   object-fit: cover;
//   border-radius: 10px;
// `;

// const FlagImg = styled.img`
//   width: 40px;
//   margin-top: 10px;
//   height: 25px;
//   object-fit: cover;
//   border-radius: 4px;
//   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

//   @media (max-width: 768px) {
//     width: 35px;
//     height: 22px;
//   }
// `;

// const TitleText = styled.h3`
//   font-size: 1.2rem;
//   font-weight: 600;
//   margin-top: 10px;
//   color: #0a2df3ff;

//   @media (max-width: 768px) {
//     font-size: 1rem;
//   }
// `;

// const CardDescription = styled.p`
//   font-size: 16px;
//   color: #7c7979ff;
//   padding: 0 10px;
//   line-height: 1.6;
//   text-align: center;
// `;

// const ResponsiveTitle = styled.h1`
//   font-size: 2.5rem;
//   text-align: center;
//   padding: 10px;
//   margin: 20px 0;

//   /* Default text (black) */
//   background: black;
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;

//   @media (max-width: 768px) {
//     font-size: 2rem;
//   }

//   @media (max-width: 480px) {
//     font-size: 1.5rem;
//   }

//   /* Span with gradient text + light background */
//   span {
//     display: inline-block;
//     padding: 5px 10px;
//     border-radius: 6px;

//     /* Background box */
//     background-color: rgba(240, 240, 240, 0.3);

//     /* Gradient text */
//     background-image: linear-gradient(90deg, #ffa600ff);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//   }
// `;

// const ReadMoreButton = styled.button`
//   background: none;
//   border: none;
//   color: #2575fc;
//   font-weight: 600;
//   cursor: pointer;
//   margin-top: 6px;
//   font-size: 14px;

//   &:hover {
//     text-decoration: underline;
//   }
// `;
// const GradientSection = styled.div`
//   width: 100%;
//   padding: 16rem 2rem; /* Desktop default */
//   background: linear-gradient(to bottom, #165a9eff, #000000ff);

//   color: white;
//   text-align: center;

//   @media (max-width: 1200px) {
//     padding: 12rem 2rem; /* Large laptops/tablets */
//   }

//   @media (max-width: 992px) {
//     padding: 10rem 1.5rem; /* Medium tablets */
//   }

//   @media (max-width: 768px) {
//     padding: 8rem 1rem; /* Small tablets / large phones */
//   }

//   @media (max-width: 480px) {
//     padding: 6rem 1rem; /* Mobile phones */
//   }
// `;

// const GradientTitle = styled.h1`
//   font-size: 2.5rem;
//   font-weight: bold;
//   margin-bottom: 1.5rem;
//   color: #ffa600ff;

//   @media (max-width: 768px) {
//     font-size: 2rem;
//   }
// `;

// const GradientText = styled.p`
//   font-size: 1.2rem;
//   line-height: 1.8;
//   max-width: 700px;
//   margin: 0 auto;

//   @media (max-width: 768px) {
//     font-size: 1rem;
//   }
// `;
// /* ---------------- FLAGS ---------------- */

// const countryFlags = {
//   USA: "https://flagcdn.com/us.svg",
//   UK: "https://flagcdn.com/gb.svg",
//   Canada: "https://flagcdn.com/ca.svg",
//   Germany: "https://flagcdn.com/de.svg",
//   France: "https://flagcdn.com/fr.svg",
//   Italy: "https://flagcdn.com/it.svg",
//   UAE: "https://flagcdn.com/ae.svg",
//   Spain: "https://flagcdn.com/es.svg",
//   Australia: "https://flagcdn.com/au.svg",
  
// };

// /* ---------------- COMPONENT ---------------- */
// const CardImageWrapper = styled.div`
//   position: relative;
//   width: 100%;
// `;

// const ShareIcon = styled.div`
//   position: absolute;
//   top: 12px;
//   right: 12px;
//   background: linear-gradient(135deg, #0d0d0eff 0%, #022533ff 100%);
//   border-radius: 50%;
//   padding: 10px;
//   cursor: pointer;
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
//   transition: all 0.3s ease;

//   display: flex;
//   align-items: center;
//   justify-content: center;

//   &:hover {
//     transform: scale(1.15) rotate(10deg);
//     background: linear-gradient(135deg, #141616ff 0%, #4facfe 100%);
//     box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
//   }

//   svg {
//     color: white;
//     font-size: 18px;
//   }
// `;

// const CardTitle = styled.div`
//   display: flex;
//   flex-direction: column; /* 👈 vertical column layout */
//   align-items: center; /* center horizontally */
//   justify-content: center;
//   text-align: center;
//   gap: 8px; /* space between flag and title */
//   margin-bottom: 10px;
// `;
// const Home = () => {
//   // same logic as before (no change)
//   // sirf UI styling update ki gayi hai
//   // 👇👇👇
//   const [email, setEmail] = useState("");
//   const [isAdmin, setIsAdmin] = useState(false);
//   const [image, setImage] = useState(null);
//   const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [url, setUrl] = useState("");
//   const [country, setCountry] = useState("");
//   const [cards, setCards] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [search, setSearch] = useState("All");
//   const [isEditing, setIsEditing] = useState(false);
//   const [editCardId, setEditCardId] = useState(null);
//   const [expandedCards, setExpandedCards] = useState({});
//   const navigate = useNavigate(); // for navigation
//   const imagePickerRef = useRef(null);
//   const handleEdit = (card) => {
//     setIsEditing(true);
//     setEditCardId(card.id);
//     setTitle(card.title);
//     setDescription(card.description);
//     setUrl(card.buyUrl);
//     setCountry(card.country || "");
//     setImage(card.url);
//     setImagePreviewUrl(card.url);

//     // 🔹 Scroll ImagePicker pe
//     if (imagePickerRef.current) {
//       imagePickerRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };
//   const toggleReadMore = (id) => {
//     setExpandedCards((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };
//   useEffect(() => {
//     const cardsRef = ref(db, "cards");
//     onValue(cardsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const loadedCards = Object.entries(data).map(([key, value]) => ({
//           id: key,
//           ...value,
//         }));
//         setCards(loadedCards.reverse());
//       }
//     });
//   }, []);

//   // const filteredCards = cards.filter((card) => {
//   //   if (search.toLowerCase() === "all") return true;
//   //   return card.country?.toLowerCase().includes(search.toLowerCase());
//   // });
//   const filteredCards = cards.filter((card) => {
//     const matchesCountry =
//       search.toLowerCase() === "all" ||
//       card.country?.toLowerCase() === search.toLowerCase();
//     const matchesSearch =
//       card.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       card.description.toLowerCase().includes(searchQuery.toLowerCase());

//     return matchesCountry && matchesSearch;
//   });

//   const handleEnterClick = () => {
//     if (email === "chohadrydanyal@gmail.com") {
//       setIsAdmin(true);
//       alert("Welcome Admin!");
//     } else {
//       setIsAdmin(false);
//       alert("You are viewing the Client Panel!");
//     }
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const storageReference = storageRef(storage, `images/${file.name}`);
//       const uploadTask = uploadBytesResumable(storageReference, file);

//       uploadTask.on(
//         "state_changed",
//         null,
//         (error) => console.error("Upload failed: ", error),
//         () => {
//           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//             setImage(downloadURL);
//             setImagePreviewUrl(URL.createObjectURL(file));
//           });
//         }
//       );
//     }
//   };

//   const handleSubmit = () => {
//     if (image && title && description && url && country) {
//       if (isEditing && editCardId) {
//         const cardRef = ref(db, "cards/" + editCardId);
//         update(cardRef, {
//           url: image,
//           title,
//           description,
//           buyUrl: url,
//           country,
//           updatedAt: new Date().toISOString(),
//         }).then(() => {
//           alert("Product updated successfully!");
//           resetForm();
//         });
//       } else {
//         const newCardRef = push(ref(db, "cards"));
//         const cardData = {
//           url: image,
//           title,
//           description,
//           buyUrl: url,
//           country,
//           createdAt: new Date().toISOString(),
//         };
//         set(newCardRef, cardData);
//         resetForm();
//       }
//     } else {
//       alert("Please fill in all fields before submitting.");
//     }
//   };

//   const handleDelete = (id) => {
//     const cardRef = ref(db, "cards/" + id);
//     remove(cardRef).then(() => alert("Product deleted!"));
//   };
//   const handleShare = (card) => {
//     const productLink = `${window.location.origin}/product/${card.id}`;

//     if (navigator.share) {
//       navigator.share({
//         title: card.title,
//         text: card.description,
//         url: productLink,
//       });
//     } else {
//       navigator.clipboard.writeText(productLink);
//       alert("Link copied: " + productLink);
//     }
//   };

//   const resetForm = () => {
//     setImage(null);
//     setImagePreviewUrl(null);
//     setTitle("");
//     setDescription("");
//     setUrl("");
//     setCountry("");
//     setIsEditing(false);
//     setEditCardId(null);
//   };

//   return (
//     <>
//       {/* <ImageSlider /> */}
//       <MainContainer>
//         <GradientSection>
//           <GradientTitle>Making the Most of Your Spending Power</GradientTitle>
//           <GradientText>
//             Find the greatest prices on your preferred item. <br />
//             We appreciate you making our affiliate website your go-to online
//             purchasing resource. <br />
//             We sincerely hope you have fun exploring our website and discovering
//             fantastic offers and goods that satisfy your tastes and
//             requirements.
//           </GradientText>

//           {/* Buttons */}
//           <ButtonContainer>
//             <GradientButton2 onClick={() => navigate("/aboutus")}>
//               <FaUserTie size={18} /> About Us
//             </GradientButton2>

//             <GradientButton2 onClick={() => navigate("/contactus")}>
//               <FaPhoneAlt size={18} /> Contact Us
//             </GradientButton2>
//           </ButtonContainer>
//         </GradientSection>

//         <ResponsiveTitle>
//           Welcome to <span>AzDanyal</span>
//         </ResponsiveTitle>

//         {/* Admin Email Input */}
//         <InputRow>
//           <StyledInput
//             type="email"
//             placeholder="Enter your email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//           <StyledButton onClick={handleEnterClick}>
//             <FaArrowRight size={18} />
//             Enter
//           </StyledButton>
//           {isAdmin && (
//             <DangerButton
//               onClick={() => {
//                 setIsAdmin(false);
//                 setEmail("");
//                 alert("You have been logged out!");
//               }}
//             >
//               Logout
//             </DangerButton>
//           )}
//         </InputRow>
//         <ResponsiveParagraph>
//           <b>AzDanyal</b> is a participant in the{" "}
//           <b>Amazon Associates Program</b>, an affiliate advertising program
//           designed to provide a means for websites to earn advertising fees by
//           promoting and linking to Amazon.com and its regional stores. We
//           carefully select trending products, provide honest recommendations,
//           and ensure that our visitors get updated deals with full transparency.
//         </ResponsiveParagraph>

//         {/* Admin Email Input */}

//         {/* Customer Search */}

//         {/* 👇 Search + Country Filter Section */}
//         <InputRow>
//           {/* Keyword Search */}
//           <StyledInput
//             type="text"
//             placeholder="Search by title or description..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />

//           {/* Country Dropdown */}
//           <CountrySelect
//             value={search} // selected country for filtering
//             onChange={(e) => setSearch(e.target.value)}
//           >
//             <option value="All">🌐 All Countries</option>
//             {Object.keys(countryFlags).map((c) => (
//               <option key={c} value={c}>
//                 {c}
//               </option>
//             ))}
//           </CountrySelect>

//           {/* Filter Button */}
//           <StyledButton onClick={() => setSearch(search || "All")}>
//             <FaSearch size={16} />Search
//           </StyledButton>
//         </InputRow>

//         {/* Admin Panel */}
//         {isAdmin && (
//           <>
//             <ImagePicker ref={imagePickerRef}>
//               <h2>
//                 {isEditing ? "Edit Product" : "Admin Panel: Add Products"}
//               </h2>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//               />
//               {imagePreviewUrl && (
//                 <ImagePreviewImg src={imagePreviewUrl} alt="Preview" />
//               )}
//               <TitleInput
//                 type="text"
//                 placeholder="Enter Product Title"
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//               />
//               <DescriptionInput
//                 placeholder="Enter Product Description"
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//               />
//               <UrlInput
//                 type="text"
//                 placeholder="Enter Product URL"
//                 value={url}
//                 onChange={(e) => setUrl(e.target.value)}
//               />
//               <CountrySelect
//                 value={country}
//                 onChange={(e) => setCountry(e.target.value)}
//               >
//                 <option value="">Select Country</option>
//                 {Object.keys(countryFlags).map((c) => (
//                   <option key={c} value={c}>
//                     {c}
//                   </option>
//                 ))}
//               </CountrySelect>

//               <SubmitButton onClick={handleSubmit}>
//                 {isEditing ? "Update Product" : "Submit"}
//               </SubmitButton>
//               {isEditing && (
//                 <CancelButton onClick={resetForm}>Cancel</CancelButton>
//               )}
//             </ImagePicker>
//             <h2>Admin Panel: All Products</h2>
//           </>
//         )}

//         {/* Products */}
//         <ImagePreviewContainer>
//           {filteredCards.length > 0 ? (
//             filteredCards.map((card) => {
//               const words = card.description.split(" ");
//               const isExpanded = expandedCards[card.id];
//               const shortText = words.slice(0, 30).join(" ");
//               const shouldTruncate = words.length > 30;

//               return (
//                 <Card key={card.id}>
//                   <CardImageWrapper>
//                     <CardImage src={card.url} alt={card.title} />
//                     <ShareIcon>
//                       <FaShareAlt />
//                     </ShareIcon>
//                   </CardImageWrapper>

//                   <CardTitle>
//                     <TitleText>{card.title}</TitleText>
//                     {card.country && countryFlags[card.country] && (
//                       <FlagImg
//                         src={countryFlags[card.country]}
//                         alt={card.country}
//                       />
//                     )}
//                   </CardTitle>

//                   <CardDescription>
//                     {isExpanded ? card.description : shortText}
//                     {shouldTruncate && (
//                       <>
//                         {!isExpanded && "..."}
//                         <br />
//                         <ReadMoreButton onClick={() => toggleReadMore(card.id)}>
//                           {isExpanded ? "Read Less" : "Read More"}
//                         </ReadMoreButton>
//                       </>
//                     )}
//                   </CardDescription>

//                   {isAdmin ? (
//                     <ButtonRow>
//                       <EditButtonStyled onClick={() => handleEdit(card)}>
//                         <FaEdit /> Edit
//                       </EditButtonStyled>
//                       <DangerButton onClick={() => handleDelete(card.id)}>
//                         <FaTrash /> Delete
//                       </DangerButton>
//                       <GradientButton
//                         onClick={() => (window.location.href = card.buyUrl)}
//                       >
//                         <FaShoppingCart /> Buy Now
//                       </GradientButton>
//                     </ButtonRow>
//                   ) : (
//                     <GradientButton1
//                       onClick={() => (window.location.href = card.buyUrl)}
//                     >
//                       <FaShoppingCart /> Buy Now
//                     </GradientButton1>
//                   )}
//                 </Card>
//               );
//             })
//           ) : (
//             <p>No products found for "{search}"</p>
//           )}
//         </ImagePreviewContainer>
//       </MainContainer>
//     </>
//   );
// };

// export default Home;


// import React, { useState, useEffect, useRef } from "react";
// import styled from "styled-components";
// import { ref, set, push, onValue, remove, update } from "firebase/database";
// import { FaEdit, FaTrash, FaShoppingCart, FaShareAlt } from "react-icons/fa";
// import { FaUserTie, FaPhoneAlt, FaArrowRight } from "react-icons/fa";

// import {
//   ref as storageRef,
//   getDownloadURL,
//   uploadBytesResumable,
// } from "firebase/storage";
// import { db, storage } from "../firebaseConfig";
// import { useNavigate } from "react-router-dom"; // top me import

// /* ---------------- BUTTONS ---------------- */

// // Common Gradient Button

// const GradientButton = styled.button`
//   padding: 12px 24px;
//   font-size: 16px;
//   font-weight: bold;
//   border: none;
//   border-radius: 50px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;

//   background: linear-gradient(45deg, #6a11cb, #2575fc);
//   color: white;
//   transition: all 0.3s ease-in-out;
//   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

//   &:hover {
//     transform: translateY(-3px) scale(1.05);
//     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
//     background: linear-gradient(45deg, #2575fc, #6a11cb);
//   }

//   svg {
//     transition: transform 0.3s ease-in-out;
//   }

//   &:hover svg {
//     transform: translateX(5px);
//   }

//   /* 🔹 Responsive */
//   @media (max-width: 768px) {
//     width: 100%;
//     font-size: 15px;
//     padding: 10px 18px;
//   }

//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px 16px;
//   }
// `;
// const GradientButton2 = styled.button`
//   padding: 12px 24px;
//   font-size: 16px;
//   font-weight: bold;
//   border: none;
//   border-radius: 50px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;

//   background: linear-gradient(45deg, #6a11cb, #2575fc);
//   color: #ffffffff;
//   transition: all 0.3s ease-in-out;
//   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

//   &:hover {
//     transform: translateY(-3px) scale(1.05);
//     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
//     background: linear-gradient(45deg, #2575fc, #6a11cb);
//   }

//   svg {
//     transition: transform 0.3s ease-in-out;
//   }

//   &:hover svg {
//     transform: translateX(5px);
//   }

//   /* 🔹 Responsive */
//   @media (max-width: 768px) {
//     width: 90%;
//     font-size: 15px;
//     padding: 10px 18px;
//   }

//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px 16px;
//   }
// `;
// const ButtonContainer = styled.div`
//   margin-top: 2rem;
//   display: flex;
//   gap: 1rem;
//   justify-content: center;
//   flex-wrap: wrap;
// `;
// const GradientButton1 = styled.button`
//   padding: 12px 24px;
//   font-size: 16px;
//   font-weight: bold;
//   border: none;
//   border-radius: 50px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   margin-top: 13px;
//   margin-bottom: 13px;
//   justify-content: center;
//   gap: 8px;

//   background: linear-gradient(45deg, #6a11cb, #2575fc);
//   color: white;
//   transition: all 0.3s ease-in-out;
//   box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

//   &:hover {
//     transform: translateY(-3px) scale(1.05);
//     box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
//     background: linear-gradient(45deg, #2575fc, #6a11cb);
//   }

//   svg {
//     transition: transform 0.3s ease-in-out;
//   }

//   &:hover svg {
//     transform: translateX(5px);
//   }

//   /* 🔹 Responsive */
//   @media (max-width: 768px) {
//     width: 90%;
//     font-size: 15px;
//     padding: 10px 18px;
//   }

//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px 16px;
//   }
// `;
// const ResponsiveParagraph = styled.p`
//   max-width: 800px;
//   margin: 20px auto;
//   text-align: center;
//   font-size: 18px;
//   line-height: 1.6;
//   color: #444;
//   padding: 0 15px;

//   @media (max-width: 768px) {
//     font-size: 14px;
//     line-height: 1.5;

//     padding: 0 10px;
//   }

//   @media (max-width: 480px) {
//     font-size: 13px;
//     line-height: 1.4;
//     padding: 0 10px;
//   }
// `;
// // Edit Button
// const EditButtonStyled = styled(GradientButton)`
//   background: linear-gradient(45deg, #f7971e, #ffd200);

//   &:hover {
//     background: linear-gradient(45deg, #ffd200, #f7971e);
//   }
// `;

// // Delete Button
// const DangerButton = styled(GradientButton)`
//   background: linear-gradient(45deg, #ff416c, #ff4b2b);

//   &:hover {
//     background: linear-gradient(45deg, #ff4b2b, #ff416c);
//   }
// `;

// // Button Row Wrapper
// const ButtonRow = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 15px;
//   margin-top: 15px;
//   flex-wrap: wrap;

//   @media (max-width: 480px) {
//     flex-direction: column;
//     width: 100%;
//     gap: 12px;

//     button {
//       width: 100%;
//       max-width: 320px;
//     }
//   }
// `;

// /* ---------------- LAYOUT + INPUTS ---------------- */

// const MainContainer = styled.div`
//   margin: 20;
//   padding: 0;
//   box-sizing: border-box;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin-bottom: 20px;
// `;

// const InputRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 12px;
//   margin: 20px auto;
//   max-width: 500px;
//   background: #f9f9f9;
//   border: 1px solid #ddd;
//   border-radius: 8px;
//   padding: 10px 15px;
//   box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

//   @media (max-width: 768px) {
//     flex-direction: column;
//     width: 90%;
//     gap: 8px;
//     padding: 12px;
//   }

//   @media (max-width: 480px) {
//     width: 100%;
//     border-radius: 6px;
//     padding: 10px;
//   }
// `;

// const StyledInput = styled.input`
//   flex: 1;
//   padding: 12px 15px;
//   border: none;
//   outline: none;
//   font-size: 16px;
//   border-radius: 6px;
//   background: white;
//   box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);

//   @media (max-width: 768px) {
//     width: 100%;
//     font-size: 15px;
//     padding: 10px 12px;
//   }

//   @media (max-width: 480px) {
//     font-size: 14px;
//     padding: 8px 10px;
//   }
// `;

// const StyledButton = styled(GradientButton)`
//   border-radius: 8px;
//   padding: 12px 24px;
//   font-size: 1rem;
//   cursor: pointer;
//   color: #ffffffff;
//   transition: all 0.3s ease;

//   &:hover {
//     transform: scale(1.05);
//   }

//   /* Tablet */
//   @media (max-width: 768px) {
//     padding: 10px 20px;
//     font-size: 0.95rem;
//   }

//   /* Mobile */
//   @media (max-width: 480px) {
//     width: 100%; /* mobile pe full width button */
//     padding: 12px;
//     font-size: 0.9rem;
//     border-radius: 6px;
//   }
// `;

// /* ---------------- IMAGE UPLOAD + FORM ---------------- */

// const ImagePicker = styled.div`
//   margin: 20px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

// const ImagePreviewContainer = styled.div`
//   width: 100%;
//   display: flex;
//   flex-wrap: wrap;
//   gap: 20px;
//   justify-content: center;
//   align-items: center;
//   margin-top: 20px;
// `;

// const ImagePreviewImg = styled.img`
//   width: 150px;
//   border-radius: 10px;
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
//   margin-bottom: 10px;
// `;

// const TitleInput = styled.input`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 18px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const DescriptionInput = styled.textarea`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   height: 100px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const UrlInput = styled.input`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const CountrySelect = styled.select`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;

// const SubmitButton = styled(GradientButton)`
//   margin-top: 20px;
//   border-radius: 8px;
// `;

// const CancelButton = styled(DangerButton)`
//   margin-top: 10px;
//   border-radius: 8px;
// `;

// /* ---------------- PRODUCT CARD ---------------- */

// const Card = styled.div`
//   border-radius: 16px;
//   width: 100%;
//   max-width: 350px;
//   padding: 15px;

//   background: #fff;
//   border: 1px solid rgba(0, 0, 0, 0.08); /* subtle border */
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding-bottom: 15px;
//   // padding: 15px;
//   transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;

//   &:hover {
//     transform: translateY(-8px) scale(1.03);
//     box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
//     border: 1px solid rgba(0, 0, 0, 0.15);
//   }

//   /* Responsive design */
//   @media (max-width: 1024px) {
//     max-width: 300px;
//     padding: 12px;
//   }

//   @media (max-width: 768px) {
//     max-width: 100%;
//     padding: 10px;
//   }

//   @media (max-width: 480px) {
//     max-width: 100%;
//     padding: 12px;
//     border-radius: 12px;
//   }
// `;

// const CardImage = styled.img`
//   width: 100%;
//   object-fit: cover;
//   border-radius: 10px;
// `;

// const FlagImg = styled.img`
//   width: 40px;
//   margin-top: 10px;
//   height: 25px;
//   object-fit: cover;
//   border-radius: 4px;
//   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

//   @media (max-width: 768px) {
//     width: 35px;
//     height: 22px;
//   }
// `;

// const TitleText = styled.h3`
//   font-size: 1.2rem;
//   font-weight: 600;
//   margin-top: 10px;
//   color: #0a2df3ff;

//   @media (max-width: 768px) {
//     font-size: 1rem;
//   }
// `;

// const CardDescription = styled.p`
//   font-size: 16px;
//   color: #7c7979ff;
//   padding: 0 10px;
//   line-height: 1.6;
//   text-align: center;
// `;

// const ResponsiveTitle = styled.h1`
//   font-size: 2.5rem;
//   text-align: center;
//   padding: 10px;
//   margin: 20px 0;

//   /* Default text (black) */
//   background: black;
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;

//   @media (max-width: 768px) {
//     font-size: 2rem;
//   }

//   @media (max-width: 480px) {
//     font-size: 1.5rem;
//   }

//   /* Span with gradient text + light background */
//   span {
//     display: inline-block;
//     padding: 5px 10px;
//     border-radius: 6px;

//     /* Background box */
//     background-color: rgba(240, 240, 240, 0.3);

//     /* Gradient text */
//     background-image: linear-gradient(90deg, #ffa600ff);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//   }
// `;

// const ReadMoreButton = styled.button`
//   background: none;
//   border: none;
//   color: #2575fc;
//   font-weight: 600;
//   cursor: pointer;
//   margin-top: 6px;
//   font-size: 14px;

//   &:hover {
//     text-decoration: underline;
//   }
// `;
// const GradientSection = styled.div`
//   width: 100%;
//   padding: 16rem 2rem; /* Desktop default */
//   background: linear-gradient(to bottom, #040274ff, #000000ff);

//   color: white;
//   text-align: center;

//   @media (max-width: 1200px) {
//     padding: 12rem 2rem; /* Large laptops/tablets */
//   }

//   @media (max-width: 992px) {
//     padding: 10rem 1.5rem; /* Medium tablets */
//   }

//   @media (max-width: 768px) {
//     padding: 8rem 1rem; /* Small tablets / large phones */
//   }

//   @media (max-width: 480px) {
//     padding: 6rem 1rem; /* Mobile phones */
//   }
// `;

// const GradientTitle = styled.h1`
//   font-size: 2.5rem;
//   font-weight: bold;
//   margin-bottom: 1.5rem;
//   color: #ffa600ff;

//   @media (max-width: 768px) {
//     font-size: 2rem;
//   }
// `;

// const GradientText = styled.p`
//   font-size: 1.2rem;
//   line-height: 1.8;
//   max-width: 700px;
//   margin: 0 auto;

//   @media (max-width: 768px) {
//     font-size: 1rem;
//   }
// `;
// /* ---------------- FLAGS ---------------- */

// const countryFlags = {
//   USA: "https://flagcdn.com/us.svg",
//   UK: "https://flagcdn.com/gb.svg",
//   Canada: "https://flagcdn.com/ca.svg",
//   Germany: "https://flagcdn.com/de.svg",
//   France: "https://flagcdn.com/fr.svg",
//   Italy: "https://flagcdn.com/it.svg",
//   UAE: "https://flagcdn.com/ae.svg",
//   Spain: "https://flagcdn.com/es.svg",
//   Australia: "https://flagcdn.com/au.svg",
//   Pakistan: "https://flagcdn.com/pk.svg",
// };

// /* ---------------- COMPONENT ---------------- */
// const CardImageWrapper = styled.div`
//   position: relative;
//   width: 100%;
// `;

// const ShareIcon = styled.div`
//   position: absolute;
//   top: 12px;
//   right: 12px;
//   background: linear-gradient(135deg, #0d0d0eff 0%, #022533ff 100%);
//   border-radius: 50%;
//   padding: 10px;
//   cursor: pointer;
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
//   transition: all 0.3s ease;

//   display: flex;
//   align-items: center;
//   justify-content: center;

//   &:hover {
//     transform: scale(1.15) rotate(10deg);
//     background: linear-gradient(135deg, #141616ff 0%, #4facfe 100%);
//     box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
//   }

//   svg {
//     color: white;
//     font-size: 18px;
//   }
// `;

// const CardTitle = styled.div`
//   display: flex;
//   flex-direction: column; /* 👈 vertical column layout */
//   align-items: center; /* center horizontally */
//   justify-content: center;
//   text-align: center;
//   gap: 8px; /* space between flag and title */
//   margin-bottom: 10px;
// `;
// const Home = () => {
//   // same logic as before (no change)
//   // sirf UI styling update ki gayi hai
//   // 👇👇👇
//   const [email, setEmail] = useState("");
//   const [isAdmin, setIsAdmin] = useState(false);
//   const [image, setImage] = useState(null);
//   const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [url, setUrl] = useState("");
//   const [country, setCountry] = useState("");
//   const [cards, setCards] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [search, setSearch] = useState("All");
//   const [isEditing, setIsEditing] = useState(false);
//   const [editCardId, setEditCardId] = useState(null);
//   const [expandedCards, setExpandedCards] = useState({});
//   const navigate = useNavigate(); // for navigation
//   const imagePickerRef = useRef(null);
//   const handleEdit = (card) => {
//     setIsEditing(true);
//     setEditCardId(card.id);
//     setTitle(card.title);
//     setDescription(card.description);
//     setUrl(card.buyUrl);
//     setCountry(card.country || "");
//     setImage(card.url);
//     setImagePreviewUrl(card.url);

//     // 🔹 Scroll ImagePicker pe
//     if (imagePickerRef.current) {
//       imagePickerRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };
//   const toggleReadMore = (id) => {
//     setExpandedCards((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };
//   useEffect(() => {
//     const cardsRef = ref(db, "cards");
//     onValue(cardsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const loadedCards = Object.entries(data).map(([key, value]) => ({
//           id: key,
//           ...value,
//         }));
//         setCards(loadedCards.reverse());
//       }
//     });
//   }, []);

//   const filteredCards = cards.filter((card) => {
//     if (search.toLowerCase() === "all") return true;
//     return card.country?.toLowerCase().includes(search.toLowerCase());
//   });

//   const handleEnterClick = () => {
//     if (email === "usmanibadmin@gmail.com") {
//       setIsAdmin(true);
//       alert("Welcome Admin!");
//     } else {
//       setIsAdmin(false);
//       alert("You are viewing the Client Panel!");
//     }
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const storageReference = storageRef(storage, `images/${file.name}`);
//       const uploadTask = uploadBytesResumable(storageReference, file);

//       uploadTask.on(
//         "state_changed",
//         null,
//         (error) => console.error("Upload failed: ", error),
//         () => {
//           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//             setImage(downloadURL);
//             setImagePreviewUrl(URL.createObjectURL(file));
//           });
//         }
//       );
//     }
//   };

//   const handleSubmit = () => {
//     if (image && title && description && url && country) {
//       if (isEditing && editCardId) {
//         const cardRef = ref(db, "cards/" + editCardId);
//         update(cardRef, {
//           url: image,
//           title,
//           description,
//           buyUrl: url,
//           country,
//           updatedAt: new Date().toISOString(),
//         }).then(() => {
//           alert("Product updated successfully!");
//           resetForm();
//         });
//       } else {
//         const newCardRef = push(ref(db, "cards"));
//         const cardData = {
//           url: image,
//           title,
//           description,
//           buyUrl: url,
//           country,
//           createdAt: new Date().toISOString(),
//         };
//         set(newCardRef, cardData);
//         resetForm();
//       }
//     } else {
//       alert("Please fill in all fields before submitting.");
//     }
//   };

//   const handleDelete = (id) => {
//     const cardRef = ref(db, "cards/" + id);
//     remove(cardRef).then(() => alert("Product deleted!"));
//   };
//   const handleShare = (card) => {
//     const productLink = `${window.location.origin}/product/${card.id}`;

//     if (navigator.share) {
//       navigator.share({
//         title: card.title,
//         text: card.description,
//         url: productLink,
//       });
//     } else {
//       navigator.clipboard.writeText(productLink);
//       alert("Link copied: " + productLink);
//     }
//   };

//   const resetForm = () => {
//     setImage(null);
//     setImagePreviewUrl(null);
//     setTitle("");
//     setDescription("");
//     setUrl("");
//     setCountry("");
//     setIsEditing(false);
//     setEditCardId(null);
//   };

//   return (
//     <>
//       {/* <ImageSlider /> */}
//       <MainContainer>
//         <GradientSection>
//           <GradientTitle>Making the Most of Your Spending Power</GradientTitle>
//           <GradientText>
//             Find the greatest prices on your preferred item. <br />
//             We appreciate you making our affiliate website your go-to online
//             purchasing resource. <br />
//             We sincerely hope you have fun exploring our website and discovering
//             fantastic offers and goods that satisfy your tastes and
//             requirements.
//           </GradientText>

//           {/* Buttons */}
//           <ButtonContainer>
//       <GradientButton2 onClick={() => navigate("/aboutus")}>
//   <FaUserTie size={18} /> About Us
// </GradientButton2>

// <GradientButton2 onClick={() => navigate("/contactus")}>
//   <FaPhoneAlt size={18} /> Contact Us
// </GradientButton2>
//     </ButtonContainer>
//         </GradientSection>

//         <ResponsiveTitle>
//           Welcome to <span>ClicknfindStore</span>
//         </ResponsiveTitle>

//         {/* Admin Email Input */}
//         <InputRow>
//           <StyledInput
//             type="email"
//             placeholder="Enter your email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//           <StyledButton onClick={handleEnterClick}><FaArrowRight size={18} />Enter</StyledButton>
//           {isAdmin && (
//             <DangerButton
//               onClick={() => {
//                 setIsAdmin(false);
//                 setEmail("");
//                 alert("You have been logged out!");
//               }}
//             >
//               Logout
//             </DangerButton>
//           )}
//         </InputRow>
//         <ResponsiveParagraph>
//           <b>ClicknfindStore</b> is a participant in the <b>Amazon Associates Program</b>, an
//           affiliate advertising program designed to provide a means for websites
//           to earn advertising fees by promoting and linking to Amazon.com and
//           its regional stores. We carefully select trending products, provide
//           honest recommendations, and ensure that our visitors get updated deals
//           with full transparency.
//         </ResponsiveParagraph>

//         {/* Admin Email Input */}

//         {/* Customer Search */}

//         <InputRow>
//           <StyledInput
//             type="text"
//             placeholder="Search by country (All, USA, UK, )..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//           <StyledButton onClick={() => setSearch(searchQuery || "All")}>
//             Search
//           </StyledButton>
//         </InputRow>
//         {/* Admin Panel */}
//         {isAdmin && (
//           <>
//             <ImagePicker ref={imagePickerRef}>
//               <h2>
//                 {isEditing ? "Edit Product" : "Admin Panel: Add Products"}
//               </h2>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//               />
//               {imagePreviewUrl && (
//                 <ImagePreviewImg src={imagePreviewUrl} alt="Preview" />
//               )}
//               <TitleInput
//                 type="text"
//                 placeholder="Enter Product Title"
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//               />
//               <DescriptionInput
//                 placeholder="Enter Product Description"
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//               />
//               <UrlInput
//                 type="text"
//                 placeholder="Enter Product URL"
//                 value={url}
//                 onChange={(e) => setUrl(e.target.value)}
//               />
//               <CountrySelect
//                 value={country}
//                 onChange={(e) => setCountry(e.target.value)}
//               >
//                 <option value="">Select Country</option>
//                 {Object.keys(countryFlags).map((c) => (
//                   <option key={c} value={c}>
//                     {c}
//                   </option>
//                 ))}
//               </CountrySelect>

//               <SubmitButton onClick={handleSubmit}>
//                 {isEditing ? "Update Product" : "Submit"}
//               </SubmitButton>
//               {isEditing && (
//                 <CancelButton onClick={resetForm}>Cancel</CancelButton>
//               )}
//             </ImagePicker>
//             <h2>Admin Panel: All Products</h2>
//           </>
//         )}

//         {/* Products */}
//         <ImagePreviewContainer>
//           {filteredCards.length > 0 ? (
//             filteredCards.map((card) => {
//               const words = card.description.split(" ");
//               const isExpanded = expandedCards[card.id];
//               const shortText = words.slice(0, 30).join(" ");
//               const shouldTruncate = words.length > 30;

//               return (

//                 <Card key={card.id}>
//                   <CardImageWrapper>
//                     <CardImage src={card.url} alt={card.title} />
//                     <ShareIcon>
//                       <FaShareAlt />
//                     </ShareIcon>
//                   </CardImageWrapper>

//                   <CardTitle>
//                     <TitleText>{card.title}</TitleText>
//                     {card.country && countryFlags[card.country] && (
//                       <FlagImg
//                         src={countryFlags[card.country]}
//                         alt={card.country}
//                       />
//                     )}
//                   </CardTitle>

//                   <CardDescription>
//                     {isExpanded ? card.description : shortText}
//                     {shouldTruncate && (
//                       <>
//                         {!isExpanded && "..."}
//                         <br />
//                         <ReadMoreButton onClick={() => toggleReadMore(card.id)}>
//                           {isExpanded ? "Read Less" : "Read More"}
//                         </ReadMoreButton>
//                       </>
//                     )}
//                   </CardDescription>

//                   {isAdmin ? (
//                     <ButtonRow>
//                       <EditButtonStyled onClick={() => handleEdit(card)}>
//                         <FaEdit /> Edit
//                       </EditButtonStyled>
//                       <DangerButton onClick={() => handleDelete(card.id)}>
//                         <FaTrash /> Delete
//                       </DangerButton>
//                       <GradientButton
//                         onClick={() => (window.location.href = card.buyUrl)}
//                       >
//                         <FaShoppingCart /> Buy Now
//                       </GradientButton>
//                     </ButtonRow>
//                   ) : (
//                     <GradientButton1
//                       onClick={() => (window.location.href = card.buyUrl)}
//                     >
//                       <FaShoppingCart /> Buy Now
//                     </GradientButton1>
//                   )}
//                 </Card>
//               );
//             })
//           ) : (
//             <p>No products found for "{search}"</p>
//           )}
//         </ImagePreviewContainer>
//       </MainContainer>
//     </>
//   );
// };

// export default Home;

import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { ref, set, push, onValue, remove, update } from "firebase/database";
import { FaEdit, FaTrash, FaShoppingCart, FaShareAlt } from "react-icons/fa";
import { FaUserTie, FaPhoneAlt, FaArrowRight, FaSearch, FaCopy } from "react-icons/fa";

import {
  ref as storageRef,
  getDownloadURL,
  uploadBytesResumable,
} from "firebase/storage";
import { db, storage } from "../firebaseConfig";
import { useNavigate } from "react-router-dom"; // top me import

/* ---------------- BUTTONS ---------------- */

// Common Gradient Button

const GradientButton = styled.button`
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background: linear-gradient(45deg, #6a11cb, #2575fc);
  color: white;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
    background: linear-gradient(45deg, #2575fc, #6a11cb);
  }

  svg {
    transition: transform 0.3s ease-in-out;
  }

  &:hover svg {
    transform: translateX(5px);
  }

  /* 🔹 Responsive */
  @media (max-width: 768px) {
    width: 100%;
    font-size: 15px;
    padding: 10px 18px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;
const GradientButton2 = styled.button`
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background: linear-gradient(45deg, #6a11cb, #2575fc);
  color: #ffffffff;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
    background: linear-gradient(45deg, #2575fc, #6a11cb);
  }

  svg {
    transition: transform 0.3s ease-in-out;
  }

  &:hover svg {
    transform: translateX(5px);
  }

  /* 🔹 Responsive */
  @media (max-width: 768px) {
    width: 90%;
    font-size: 15px;
    padding: 10px 18px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;
const ButtonContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;
const GradientButton1 = styled.button`
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 13px;
  margin-bottom: 13px;
  justify-content: center;
  gap: 8px;

  background: linear-gradient(45deg, #6a11cb, #2575fc);
  color: white;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
    background: linear-gradient(45deg, #2575fc, #6a11cb);
  }

  svg {
    transition: transform 0.3s ease-in-out;
  }

  &:hover svg {
    transform: translateX(5px);
  }

  /* 🔹 Responsive */
  @media (max-width: 768px) {
    width: 90%;
    font-size: 15px;
    padding: 10px 18px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;
const ResponsiveParagraph = styled.p`
  max-width: 800px;
  margin: 20px auto;
  text-align: center;
  font-size: 18px;
  line-height: 1.6;
  color: #444;
  padding: 0 15px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.5;

    padding: 0 10px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 1.4;
    padding: 0 10px;
  }
`;
// Edit Button
const EditButtonStyled = styled(GradientButton)`
  background: linear-gradient(45deg, #f7971e, #ffd200);

  &:hover {
    background: linear-gradient(45deg, #ffd200, #f7971e);
  }
`;

// Delete Button
const DangerButton = styled(GradientButton)`
  background: linear-gradient(45deg, #ff416c, #ff4b2b);

  &:hover {
    background: linear-gradient(45deg, #ff4b2b, #ff416c);
  }
`;

// Button Row Wrapper
const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    gap: 12px;

    button {
      width: 100%;
      max-width: 320px;
    }
  }
`;

/* ---------------- LAYOUT + INPUTS ---------------- */

const MainContainer = styled.div`
  margin: 20;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 20px auto;
  max-width: 500px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 15px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    width: 90%;
    gap: 8px;
    padding: 12px;
  }

  @media (max-width: 480px) {
    width: 100%;
    border-radius: 6px;
    padding: 10px;
  }
`;

const StyledInput = styled.input`
  flex: 1;
  padding: 12px 15px;
  border: none;
  outline: none;
  font-size: 16px;
  border-radius: 6px;
  background: white;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    width: 100%;
    font-size: 15px;
    padding: 10px 12px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px 10px;
  }
`;

const StyledButton = styled(GradientButton)`
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  cursor: pointer;
  color: #ffffffff;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  /* Tablet */
  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 0.95rem;
  }

  /* Mobile */
  @media (max-width: 480px) {
    width: 100%; /* mobile pe full width button */
    padding: 12px;
    font-size: 0.9rem;
    border-radius: 6px;
  }
`;

/* ---------------- IMAGE UPLOAD + FORM ---------------- */

const ImagePicker = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImagePreviewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

const ImagePreviewImg = styled.img`
  width: 150px;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
`;

const TitleInput = styled.input`
  margin-top: 10px;
  padding: 10px;
  font-size: 18px;
  width: 100%;
  max-width: 400px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

const DescriptionInput = styled.textarea`
  margin-top: 10px;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  max-width: 400px;
  height: 100px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

const UrlInput = styled.input`
  margin-top: 10px;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  max-width: 400px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

// const CountrySelect = styled.select`
//   margin-top: 10px;
//   padding: 10px;
//   font-size: 16px;
//   width: 100%;
//   max-width: 400px;
//   border-radius: 5px;
//   border: 1px solid #ccc;
// `;
const CountrySelect = styled.select`
  
  padding: 10px 12px;
  font-size: 16px;
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
  border: 1px solid #ccc;
  outline: none;
  background: #fff;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:focus {
    border-color: #2575fc;
    box-shadow: 0 0 6px rgba(37, 117, 252, 0.5);
  }

  /* Tablet */
  @media (max-width: 768px) {
    font-size: 15px;
    padding: 10px;
    max-width: 100%;
  }

  /* Mobile */
  @media (max-width: 480px) {
    font-size: 14px;
    padding: 8px;
    width: 100%;
    border-radius: 6px;
  }
`;

const SubmitButton = styled(GradientButton)`
  margin-top: 20px;
  border-radius: 8px;
`;

const CancelButton = styled(DangerButton)`
  margin-top: 10px;
  border-radius: 8px;
`;

/* ---------------- PRODUCT CARD ---------------- */

const Card = styled.div`
  border-radius: 16px;
  width: 100%;
  max-width: 350px;
  padding: 15px;

  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08); /* subtle border */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 15px;
  // padding: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;

  &:hover {
    transform: translateY(-8px) scale(1.03);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  /* Responsive design */
  @media (max-width: 1024px) {
    max-width: 300px;
    padding: 12px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 10px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    padding: 12px;
    border-radius: 12px;
  }
`;

const CardImage = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
`;

const FlagImg = styled.img`
  width: 40px;
  margin-top: 10px;
  height: 25px;
  object-fit: cover;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    width: 35px;
    height: 22px;
  }
`;

const TitleText = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 10px;
  color: #0a2df3ff;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const CardDescription = styled.p`
  font-size: 16px;
  color: #7c7979ff;
  padding: 0 10px;
  line-height: 1.6;
  text-align: center;
`;

const ResponsiveTitle = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  padding: 10px;
  margin: 20px 0;

  /* Default text (black) */
  background: black;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }

  /* Span with gradient text + light background */
  span {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 6px;

    /* Background box */
    background-color: rgba(240, 240, 240, 0.3);

    /* Gradient text */
    background-image: linear-gradient(90deg, #ffa600ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const ReadMoreButton = styled.button`
  background: none;
  border: none;
  color: #2575fc;
  font-weight: 600;
  cursor: pointer;
  margin-top: 6px;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`;
const GradientSection = styled.div`
  width: 100%;
  padding: 16rem 2rem; /* Desktop default */
  background: linear-gradient(to bottom, #165a9eff, #000000ff);

  color: white;
  text-align: center;

  @media (max-width: 1200px) {
    padding: 12rem 2rem; /* Large laptops/tablets */
  }

  @media (max-width: 992px) {
    padding: 10rem 1.5rem; /* Medium tablets */
  }

  @media (max-width: 768px) {
    padding: 8rem 1rem; /* Small tablets / large phones */
  }

  @media (max-width: 480px) {
    padding: 6rem 1rem; /* Mobile phones */
  }
`;

const GradientTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: #ffa600ff;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const GradientText = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  max-width: 700px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;
/* ---------------- FLAGS ---------------- */

// const countryFlags = {
//   USA: "https://flagcdn.com/us.svg",
//   UK: "https://flagcdn.com/gb.svg",
//   Canada: "https://flagcdn.com/ca.svg",
//   Germany: "https://flagcdn.com/de.svg",
//   France: "https://flagcdn.com/fr.svg",
//   Italy: "https://flagcdn.com/it.svg",
//   UAE: "https://flagcdn.com/ae.svg",
//   Spain: "https://flagcdn.com/es.svg",
//   Australia: "https://flagcdn.com/au.svg",
  
// };
const countryFlags = {
  USA: "https://flagcdn.com/us.svg",
  UK: "https://flagcdn.com/gb.svg",
  Canada: "https://flagcdn.com/ca.svg",
  Germany: "https://flagcdn.com/de.svg",
  France: "https://flagcdn.com/fr.svg",
  Italy: "https://flagcdn.com/it.svg",
  UAE: "https://flagcdn.com/ae.svg",
  Spain: "https://flagcdn.com/es.svg",
  Australia: "https://flagcdn.com/au.svg",
  KSA: "https://flagcdn.com/sa.svg"  // ← Saudi Arabia
};

/* ---------------- COMPONENT ---------------- */
const CardImageWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const ShareIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #0d0d0eff 0%, #022533ff 100%);
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.15) rotate(10deg);
    background: linear-gradient(135deg, #141616ff 0%, #4facfe 100%);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
  }

  svg {
    color: white;
    font-size: 18px;
  }
`;

const CardTitle = styled.div`
  display: flex;
  flex-direction: column; /* 👈 vertical column layout */
  align-items: center; /* center horizontally */
  justify-content: center;
  text-align: center;
  gap: 8px; /* space between flag and title */
  margin-bottom: 10px;
`;
const Home = () => {
  // same logic as before (no change)
  // sirf UI styling update ki gayi hai
  // 👇👇👇
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");
  const [country, setCountry] = useState("");
  const [cards, setCards] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [search, setSearch] = useState("All");
  const [isEditing, setIsEditing] = useState(false);
  const [editCardId, setEditCardId] = useState(null);
  const [expandedCards, setExpandedCards] = useState({});
  const navigate = useNavigate(); // for navigation
  const imagePickerRef = useRef(null);
  const handleEdit = (card) => {
    setIsEditing(true);
    setEditCardId(card.id);
    setTitle(card.title);
    setDescription(card.description);
    setUrl(card.buyUrl);
    setCountry(card.country || "");
    setImage(card.url);
    setImagePreviewUrl(card.url);

    // 🔹 Scroll ImagePicker pe
    if (imagePickerRef.current) {
      imagePickerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const toggleReadMore = (id) => {
    setExpandedCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  useEffect(() => {
    const cardsRef = ref(db, "cards");
    onValue(cardsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const loadedCards = Object.entries(data).map(([key, value]) => ({
          id: key,
          ...value,
        }));
        setCards(loadedCards.reverse());
      }
    });
  }, []);

  // const filteredCards = cards.filter((card) => {
  //   if (search.toLowerCase() === "all") return true;
  //   return card.country?.toLowerCase().includes(search.toLowerCase());
  // });
  const filteredCards = cards.filter((card) => {
    const matchesCountry =
      search.toLowerCase() === "all" ||
      card.country?.toLowerCase() === search.toLowerCase();
    const matchesSearch =
      card.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      card.description.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesCountry && matchesSearch;
  });

  const handleEnterClick = () => {
    if (email === "pakizaadmin786@gmail.com") {
      setIsAdmin(true);
      alert("Welcome Admin!");
    } else {
      setIsAdmin(false);
      alert("You are viewing the Client Panel!");
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const storageReference = storageRef(storage, `images/${file.name}`);
      const uploadTask = uploadBytesResumable(storageReference, file);

      uploadTask.on(
        "state_changed",
        null,
        (error) => console.error("Upload failed: ", error),
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            setImage(downloadURL);
            setImagePreviewUrl(URL.createObjectURL(file));
          });
        }
      );
    }
  };

  const handleSubmit = () => {
    if (image && title && description && url && country) {
      if (isEditing && editCardId) {
        const cardRef = ref(db, "cards/" + editCardId);
        update(cardRef, {
          url: image,
          title,
          description,
          buyUrl: url,
          country,
          updatedAt: new Date().toISOString(),
        }).then(() => {
          alert("Product updated successfully!");
          resetForm();
        });
      } else {
        const newCardRef = push(ref(db, "cards"));
        const cardData = {
          url: image,
          title,
          description,
          buyUrl: url,
          country,
          createdAt: new Date().toISOString(),
        };
        set(newCardRef, cardData);
        resetForm();
      }
    } else {
      alert("Please fill in all fields before submitting.");
    }
  };
const handleCopyLink = (card) => {
    const productLink = `${window.location.origin}/product/${card.id}`;
    navigator.clipboard.writeText(productLink);
    alert("Product link copied: " + productLink);
  };
  const handleDelete = (id) => {
    const cardRef = ref(db, "cards/" + id);
    remove(cardRef).then(() => alert("Product deleted!"));
  };
  const handleShare = (card) => {
    const productLink = `${window.location.origin}/product/${card.id}`;

    if (navigator.share) {
      navigator.share({
        title: card.title,
        text: card.description,
        url: productLink,
      });
    } else {
      navigator.clipboard.writeText(productLink);
      alert("Link copied: " + productLink);
    }
  };

  const resetForm = () => {
    setImage(null);
    setImagePreviewUrl(null);
    setTitle("");
    setDescription("");
    setUrl("");
    setCountry("");
    setIsEditing(false);
    setEditCardId(null);
  };

  return (
    <>
      {/* <ImageSlider /> */}
      <MainContainer>
      
        <GradientSection>
          <GradientTitle>Making the Most of Your Spending Power</GradientTitle>
          <GradientText>
            Find the greatest prices on your preferred item. <br />
            We appreciate you making our affiliate website your go-to online
            purchasing resource. <br />
            We sincerely hope you have fun exploring our website and discovering
            fantastic offers and goods that satisfy your tastes and
            requirements.
          </GradientText>

          {/* Buttons */}
          <ButtonContainer>
            <GradientButton2 onClick={() => navigate("/aboutus")}>
              <FaUserTie size={18} /> About Us
            </GradientButton2>

            <GradientButton2 onClick={() => navigate("/contactus")}>
              <FaPhoneAlt size={18} /> Contact Us
            </GradientButton2>
          </ButtonContainer>
        </GradientSection>

        <ResponsiveTitle>
          Welcome to <span>AzDanyal</span>
        </ResponsiveTitle>

        {/* Admin Email Input */}
        <InputRow>
          <StyledInput
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <StyledButton onClick={handleEnterClick}>
            <FaArrowRight size={18} />
            Enter
          </StyledButton>
          {isAdmin && (
            <DangerButton
              onClick={() => {
                setIsAdmin(false);
                setEmail("");
                alert("You have been logged out!");
              }}
            >
              Logout
            </DangerButton>
          )}
        </InputRow>
        <ResponsiveParagraph>
          <b>AzDanyal</b> is a participant in the{" "}
          <b>Amazon Associates Program</b>, an affiliate advertising program
          designed to provide a means for websites to earn advertising fees by
          promoting and linking to Amazon.com and its regional stores. We
          carefully select trending products, provide honest recommendations,
          and ensure that our visitors get updated deals with full transparency.
        </ResponsiveParagraph>

        {/* Admin Email Input */}

        {/* Customer Search */}

        {/* 👇 Search + Country Filter Section */}
        <InputRow>
          {/* Keyword Search */}
          <StyledInput
            type="text"
            placeholder="Search by title or description..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          {/* Country Dropdown */}
          <CountrySelect
            value={search} // selected country for filtering
            onChange={(e) => setSearch(e.target.value)}
          >
            <option value="All">🌐 All Countries</option>
            {Object.keys(countryFlags).map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </CountrySelect>

          {/* Filter Button */}
          <StyledButton onClick={() => setSearch(search || "All")}>
            <FaSearch size={16} />Search
          </StyledButton>
        </InputRow>

        {/* Admin Panel */}
        {isAdmin && (
          <>
            <ImagePicker ref={imagePickerRef}>
              <h2>
                {isEditing ? "Edit Product" : "Admin Panel: Add Products"}
              </h2>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
              {imagePreviewUrl && (
                <ImagePreviewImg src={imagePreviewUrl} alt="Preview" />
              )}
              <TitleInput
                type="text"
                placeholder="Enter Product Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <DescriptionInput
                placeholder="Enter Product Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <UrlInput
                type="text"
                placeholder="Enter Product URL"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
              />
              <CountrySelect
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              >
                <option value="">Select Country</option>
                {Object.keys(countryFlags).map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </CountrySelect>

              <SubmitButton onClick={handleSubmit}>
                {isEditing ? "Update Product" : "Submit"}
              </SubmitButton>
              {isEditing && (
                <CancelButton onClick={resetForm}>Cancel</CancelButton>
              )}
            </ImagePicker>
            <h2>Admin Panel: All Products</h2>
          </>
        )}

        {/* Products */}
        <ImagePreviewContainer>
          {filteredCards.length > 0 ? (
            filteredCards.map((card) => {
              const words = card.description.split(" ");
              const isExpanded = expandedCards[card.id];
              const shortText = words.slice(0, 30).join(" ");
              const shouldTruncate = words.length > 30;

              return (
                <Card key={card.id}>
                  <CardImageWrapper>
                    <CardImage src={card.url} alt={card.title} />

                    {/* Share Icon */}
                    <ShareIcon  style={{ background: "#1151c0" }} onClick={() => handleShare(card)}>
                      <FaShareAlt />
                    </ShareIcon>

                    {/* Copy Icon */}
                    <ShareIcon
                      style={{ top:"60px", background: "#1151c0" }}
                      onClick={() => handleCopyLink(card)}
                    >
                      <FaCopy />
                    </ShareIcon>
                  </CardImageWrapper>


                  <CardTitle>
                    <TitleText>{card.title}</TitleText>
                    {card.country && countryFlags[card.country] && (
                      <FlagImg
                        src={countryFlags[card.country]}
                        alt={card.country}
                      />
                    )}
                  </CardTitle>

                  <CardDescription>
                    {isExpanded ? card.description : shortText}
                    {shouldTruncate && (
                      <>
                        {!isExpanded && "..."}
                        <br />
                        <ReadMoreButton onClick={() => toggleReadMore(card.id)}>
                          {isExpanded ? "Read Less" : "Read More"}
                        </ReadMoreButton>
                      </>
                    )}
                  </CardDescription>

                  {isAdmin ? (
                    <ButtonRow>
                      <EditButtonStyled onClick={() => handleEdit(card)}>
                        <FaEdit /> Edit
                      </EditButtonStyled>
                      <DangerButton onClick={() => handleDelete(card.id)}>
                        <FaTrash /> Delete
                      </DangerButton>
                      <GradientButton
                        onClick={() => (window.location.href = card.buyUrl)}
                      >
                        <FaShoppingCart /> Buy Now
                      </GradientButton>
                    </ButtonRow>
                  ) : (
                    <GradientButton1
                      onClick={() => (window.location.href = card.buyUrl)}
                    >
                      <FaShoppingCart /> Buy Now
                    </GradientButton1>
                  )}
                </Card>
              );
            })
          ) : (
            <p>No products found for "{search}"</p>
          )}
        </ImagePreviewContainer>
      </MainContainer>
    </>
  );
};

export default Home;
